import { db } from '../firebase';
import { collection, getDocs, doc, deleteDoc, query, where, writeBatch } from 'firebase/firestore'; // Add writeBatch here

export const getGuppies = async () => {
  const guppyCollection = collection(db, 'guppies');
  const snapshot = await getDocs(guppyCollection);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const confirmOrder = async (orderId, items) => {
  const batch = writeBatch(db); // Now writeBatch is defined

  // Update the order status to "Confirmed"
  const orderRef = doc(db, 'orders', orderId);
  batch.update(orderRef, { status: 'Confirmed' });

  // Mark guppies as sold
  for (const item of items) {
    const guppyName = item.name;
    const guppyQuery = query(
      collection(db, 'guppies'),
      where('name', '==', guppyName),
      where('sold_status', '==', false)
    );
    const guppySnapshot = await getDocs(guppyQuery);
    if (guppySnapshot.docs.length > 0) {
      const guppyRef = doc(db, 'guppies', guppySnapshot.docs[0].id);
      batch.update(guppyRef, { sold_status: true });
    }
  }

  await batch.commit();
};

export const deleteOrder = async (orderId) => {
  await deleteDoc(doc(db, 'orders', orderId));
};